import * as React from 'react';
import { ValidationError } from '../../infrastructure/ValidationResult';
import { Row, Col } from '../../uiComponents/bootstrap-components/BootstrapComponents';
import { TextFormGroup } from '../../uiComponents/input/FormGroups';
import { MultipleChoiceSvarmulighed } from '../../models/MultipleChoiceSvarmulighed';
import { RoundBtn } from '../../uiComponents/input/Buttons';

export interface SvarmulighedComponentProps {
    multipleChoiceSvarmulighed: MultipleChoiceSvarmulighed;
    index: number;
    delopgaveIndex: number;
    multipleChoiceSpoergsmaalIndex: number;
    removeSvarmulighed: (key: any, delopgaveIndex: number, multipleChoiceSpoergsmaalIndex: number) => void;
    onSvarmulighedChanged: (fieldName: string, value: any, index: number, delopgaveIndex: number, multipleChoiceSpoergsmaalIndex: number) => void;
    errorMessages: ValidationError[];
}

class SvarmulighedComponent extends React.Component<SvarmulighedComponentProps, any> {
    constructor(props: SvarmulighedComponentProps) {
        super(props);
        this.onChange = this.onChange.bind(this);
        this.getLabel = this.getLabel.bind(this);
        this.getBtnGroupClass = this.getBtnGroupClass.bind(this);
        this.getSvarmulighedBtnIconName = this.getSvarmulighedBtnIconName.bind(this);
        this.setSvarIsKorrekt = this.setSvarIsKorrekt.bind(this);
        this.getSvarmulighedBtnClassName = this.getSvarmulighedBtnClassName.bind(this);
    }

    onChange(field: string, value: string) {
        this.props.onSvarmulighedChanged(field, value, this.props.index, this.props.delopgaveIndex, this.props.multipleChoiceSpoergsmaalIndex);
    }

    getLabel() {
        if (this.props.index === 0) {
            return 'Svar';
        }

        return '';
    }

    getBtnGroupClass() {
        let classes = 'svarmulighed-btn-group';
        return this.props.index === 0 ? classes + ' first' : classes;
    }

    getSvarmulighedBtnIconName() {
        return this.props.multipleChoiceSvarmulighed.isKorrekt ? 'success' : 'minus';
    }

    getSvarmulighedBtnClassName() {
        let classes = 'svarmulighed-btn pull-left';
        return this.props.multipleChoiceSvarmulighed.isKorrekt ? classes + ' active' : classes;
    }

    setSvarIsKorrekt() {
        this.props.onSvarmulighedChanged('isKorrekt', !this.props.multipleChoiceSvarmulighed.isKorrekt, this.props.index, this.props.delopgaveIndex, this.props.multipleChoiceSpoergsmaalIndex);
    }

    render() {
        return (
            <div className='svarmulighed'>
                <Row>
                    <Col md={10}>
                        <TextFormGroup
                            errorMessages={this.props.errorMessages}
                            label={this.getLabel()}
                            name='svarmulighed'
                            placeholder='Angiv svarmulighed'
                            value={this.props.multipleChoiceSvarmulighed.svarmulighed}
                            onChange={this.onChange}
                        />
                    </Col>
                    <Col className={this.getBtnGroupClass()} md={2}>
                        <RoundBtn
                            className={this.getSvarmulighedBtnClassName()}
                            buttonOnClick={this.setSvarIsKorrekt}
                            iconName={this.getSvarmulighedBtnIconName()}
                        />
                        <RoundBtn
                            className='svarmulighed-btn pull-right'
                            buttonOnClick={() => this.props.removeSvarmulighed(this.props.index, this.props.delopgaveIndex, this.props.multipleChoiceSpoergsmaalIndex)}
                            iconName='close'
                        />
                    </Col>
                </Row>
            </div>
        );
    }
}

export default SvarmulighedComponent;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/pageComponents/opgave/SvarmulighedComponent.tsx